import { observer } from 'mobx-react-lite';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import CheckBox from '../../../../../../../atomic/formElements/checkBox/CheckBox';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const CandleBreakTacticPanel = observer(
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const { quantityBasis, inPosition } = tradePlan;
    const updateMarketOrder = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'CANDLE_BREAK',
        tradePlanId,
        null
      );
    };
    if (!tradePlan) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    {quantityBasis === 'DOLLARS'
                      ? 'Dollar Amount'
                      : 'Qty. Amount'}
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    {quantityBasis === 'DOLLARS' ? '$' : '#'}
                  </Body3>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['CANDLE_BREAK'].quantityBasisValue
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['CANDLE_BREAK']
                            .quantityBasisValue
                      )
                        updateMarketOrder('quantityBasisValue', newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Candle Duration
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <EditableTableField
                    margin="0 5px 0 0"
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.black}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['CANDLE_BREAK'].candleDuration
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['CANDLE_BREAK'].candleDuration
                      )
                        updateMarketOrder('candleDuration', newValue);
                    }}
                    inputType="number"
                  />
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    min.
                  </Body3>
                </td>
              </tr>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Break By
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <Body3
                    fontWeight={700}
                    color={colors.lightGrey}
                    margin="3px 3px 0 0"
                  >
                    $
                  </Body3>
                  <EditableTableField
                    color={colors.lightGrey}
                    bodySize={3}
                    backgroundColor={colors.grey}
                    disabled={inPosition}
                    initialValue={
                      tradePlan.entryTactics['CANDLE_BREAK'].breakBy
                    }
                    updateValue={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['CANDLE_BREAK'].breakBy
                      )
                        updateMarketOrder('breakBy', newValue);
                    }}
                    inputType="number"
                  />
                </td>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Wait for Current Candle Close
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <CheckBox
                    fontSize="10px"
                    margin="auto 5px"
                    checked={
                      tradePlan.entryTactics['CANDLE_BREAK']
                        .waitUntilCurrentCandleCloses
                    }
                    onChange={(newValue) => {
                      if (
                        newValue !== 0 &&
                        newValue !==
                          tradePlan.entryTactics['CANDLE_BREAK']
                            .waitUntilCurrentCandleCloses
                      )
                        updateMarketOrder(
                          'waitUntilCurrentCandleCloses',
                          newValue
                        );
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);
CandleBreakTacticPanel.tabsRole = 'TabPanel';
